module.exports = __webpack_public_path__ + "media/honey-icons/icon-not-flowing-95aea218.svg";